/**
 * Handles http requests
 * @see - https://dmitripavlutin.com/fetch-with-json/
 */

export default {

    get ( path = '', params = {}) {
        return this.make ('GET', this.path(path, params) );
    },

    post ( path, params = {}) {
        return this.make ( 'POST', path, params );
    },

    path ( path = '', params = {}) {
        return path + (Object.keys(params).length ? (path.includes('?') ? '&' : '?') + new URLSearchParams(params).toString() : '');
    },

    make ( method, path, params ) {
        return new Promise((resolve, reject) => {
            fetch(path, {
                headers: {
                    "Content-Type": "application/json",
                    'X-Requested-With': 'XMLHttpRequest'
                },
                method: method,
                credentials: 'include',
                body: JSON.stringify(params)
            }).then((r) => {
                return r.json();
            }).then((r) => {
                resolve(r);
            }).catch((e => {
                reject(e);
            }));
        })
    }
};


